module.exports = __webpack_public_path__ + "img/banner.04aa6801.png";